import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import api from '../../lib/api';
import { useAuth } from '../../context/AuthContext';

export default function ChangePassword() {
  const { refresh, user } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ current_password: '', new_password: '', confirm: '' });
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr('');
    if (form.new_password !== form.confirm) { setErr('Passwords do not match'); return; }
    if (form.new_password.length < 10) { setErr('New password must be at least 10 characters'); return; }
    setBusy(true);
    try {
      await api.post('/auth/change-password', { current_password: form.current_password, new_password: form.new_password });
      await refresh();
      nav('/admin');
    } catch (e2) {
      setErr(e2.response?.data?.detail || 'Unable to change password');
    } finally { setBusy(false); }
  };

  return (
    <div className="max-w-md">
      <div className="flex items-center gap-3 mb-6">
        <KeyRound className="h-6 w-6 text-sage-400" />
        <h1 className="font-serif text-cream-50 text-3xl">Change password</h1>
      </div>
      {user?.must_change_password && <div className="mb-4 border border-sage-500/40 bg-sage-500/10 text-sage-300 text-sm px-3 py-2">Please set a new password before continuing.</div>}
      <form onSubmit={submit} className="bg-forest-900 border border-forest-800 p-6 space-y-4">
        {err && <div className="border border-red-500/40 bg-red-500/10 text-red-300 text-sm px-3 py-2">{err}</div>}
        {['current_password','new_password','confirm'].map((k, i) => (
          <div key={k}>
            <label className="block text-xs uppercase tracking-widest text-cream-100/60 mb-1.5">{['Current password','New password','Confirm new password'][i]}</label>
            <input type="password" value={form[k]} onChange={(e) => setForm({ ...form, [k]: e.target.value })} className="w-full bg-forest-950 border border-forest-700 focus:border-sage-500 outline-none px-3 py-2 text-sm text-cream-50" required />
          </div>
        ))}
        <button disabled={busy} className="w-full bg-sage-500 text-forest-900 py-3 text-sm font-medium hover:bg-sage-600 disabled:opacity-60">{busy ? 'Saving…' : 'Update password'}</button>
      </form>
    </div>
  );
}
